export function intiAccordions() {
  const accWrapper = document.querySelector('.landing-accordion-wrapper');
  if (!accWrapper) return;
  const accordions = [...accWrapper.querySelectorAll('.landing-accordion')];
  const triggers = [...accWrapper.querySelectorAll('.landing-accordion-trigger')];

  function toggleAccordion(ev) {
    accordions.forEach((acc) => {
      [...acc.children].forEach((child) => {
        child.classList.remove('is-open', 'text-gradient-dark');
      });
    });
    const parent = ev.target.closest('.landing-accordion');
    [...parent.children].forEach((child, i) => {
      if (i === 0) child.classList.add('text-gradient-dark');
      if (i === 1) child.classList.add('is-open');
    });
    parent.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  triggers.forEach((acc) => {
    acc.addEventListener('click', toggleAccordion);
  })
}